import React from 'react';
import PropTypes from 'prop-types';
import Notification from '../common/notification/notification.component';
import { Row, Grid, Col, PanelGroup, Checkbox } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import DelegationLogService from './delegationlog.service';
import Loading from '../loading/loading.component';
import * as consts from '../../const.js';
import { generateIteratorKey as keygen } from '../../utils/helpers';

const columns = {
  user: consts.DL_COLUMN_USER,
  assigned: consts.DL_COLUMN_ASSIGNED,
  organization: consts.DL_COLUMN_ORGANIZATION,
  country: consts.DL_COLUMN_COUNTRY,
  actions: consts.VIEW
};

class DelegationLog extends React.Component {
  constructor(props) {
    super(props);

    this.expandAll = this.expandAll.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      activeKey: '1',
      all: false
    };
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  expandAll() {
    this.setState({ all: !this.state.all });
    this.setState({ activeKey: '1' });
  }

  componentDidMount() {
    this.props.loadData(this.props.sponsor.databasename, this.props.studyGid);
  }

  render() {
    let rows = [],
      notification = <i />,
      notificationExport = <i />;
    let collapseVisibility, exportVisibility, acordeonLabel;

    if (this.props.isFetchingExport) {
      notificationExport = <Loading />;
    } else if (this.props.errorExport) {
      notificationExport = <Notification type="error" data={this.props.errorExport} />;
    }

    if (this.props.isFetching) {
      notification = <Loading />;
    } else if (this.props.error) {
      notification = <Notification type="error" data={this.props.error} />;
    }

    if (this.props.assignments && this.props.assignments.length > 0) {
      rows = DelegationLogService.createGrid(this.props.study, this.props.assignments, this.state.all);
    }

    if (rows && rows.length == 0 && !this.props.isFetching) {
      notification = <Notification type="info" data={consts.NO_DELEGATION_LOGS} />;
    }

    collapseVisibility = this.props.getVisibility(rows);
    exportVisibility = this.props.getVisibility(rows);

    acordeonLabel = this.state.all ? consts.DL_COLUMN_COLLAPSE : consts.DL_COLUMN_EXPAND;
    return (
      <div id="delegation-log">
        {notificationExport}
        <Grid fluid id="delegation-log-grid" className="tc-grid">
          <Row {...keygen()} className="tc-grid-header delegation-log-header">
            <Col sm={4} lg={4} className="delegation-log-col">
              {columns.organization}
            </Col>
            <Col sm={8} lg={8}>
              <Checkbox className={`${collapseVisibility}`} checked={this.state.all} onClick={this.expandAll}>
                {acordeonLabel}
              </Checkbox>
            </Col>
          </Row>

          <PanelGroup id="personnel-list" accordion activeKey={this.state.activeKey} onSelect={this.handleSelect}>
            {rows}
          </PanelGroup>
          {notification}
        </Grid>
      </div>
    );
  }
}

DelegationLog.propTypes = {
  assignments: PropTypes.array,
  error: PropTypes.object,
  isFetching: PropTypes.bool,
  studyGid: PropTypes.string,
  study: PropTypes.object,
  loadData: PropTypes.func
};

export default DelegationLog;
